import React, {Component} from 'react';
import {Factory} from './components/mobile/factory';
import {connect} from 'react-redux';
import UsedTeamsContainer from './components/mobile/container';

class UsedTeams extends Component {
    render() {
        const {sportConfig} = this.props;
        const ViewComponent = Factory.getComponent(sportConfig);

        if (ViewComponent) {
            return (
                <UsedTeamsContainer>
                    <ViewComponent />
                </UsedTeamsContainer>
            );
        }

        return null;
    }
}

function mapStatesToProps(state) {
    const {sportConfig} = state;
    return {
        sportConfig,
    };
}

const UsedTeamsComponent = connect(mapStatesToProps)(UsedTeams);

export {UsedTeamsComponent};
